module.exports = __webpack_public_path__ + "img/social-boxing-gloves.7b8ea80b.jpg";